import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { 
  FaGamepad, 
  FaUsers, 
  FaDoorOpen, 
  FaLock, 
  FaClock, 
  FaCircle,
  FaFrown,
  FaCalendarAlt
} from 'react-icons/fa';
import { BiLoaderAlt } from 'react-icons/bi';
import Navbar from './navbar';
import BottomBar from './BottomBar';
import './ongoing-matches.css';

const OngoingMatches = () => {
  const [joinedMatches, setJoinedMatches] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  

  const fetchJoinedMatches = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('https://backend.aubattle.com/api/matches/joined', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const ongoingMatches = res.data.filter(match => match.status !== 'completed');
      setJoinedMatches(ongoingMatches);
    } catch (err) {
      console.error('Error fetching matches:', err);
    } finally {
      setIsLoading(false);
      
    }
  };

  

  useEffect(() => {
    fetchJoinedMatches();
  }, []);

  return (
    <div className="ongoing-matches-container">
      <Navbar />
      
      <div className="matches-content">
        <div className="matches-header">
          <div className="title-section">
            <FaGamepad className="title-icon" />
            <h1>Your Ongoing Battles</h1>
          </div>
         
        </div>

        {isLoading ? (
          <div className="loading-state">
            <BiLoaderAlt className="spinner" />
            <p>Loading your battles...</p>
          </div>
        ) : joinedMatches.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">
              <FaFrown />
            </div>
            <h3>No Active Battles</h3>
            <p>Join matches to see them appear here</p>
           
          </div>
        ) : (
          <div className="matches-grid">
            {joinedMatches.map((match) => (
              <div key={match.id} className="match-card">
                <div className="card-header">
                  <div className={`status-badge ${match.status}`}>
                    {match.status === 'started' ? (
                      <>
                        <FaCircle className="pulse" /> LIVE
                      </>
                    ) : (
                      <>
                        <FaClock /> {match.status.charAt(0).toUpperCase() + match.status.slice(1)}
                      </>
                    )}
                  </div>
                  <h3 className="match-title">{match.title || 'Untitled Match'}</h3>
                  <span className="match-id">#{match.id}</span>
                </div>
                
                <div className="card-body">
                  <div className="info-row">
                    <FaDoorOpen className="info-icon" />
                    <div className="info-text">
                      <span className="info-label">Room ID:</span>
                      <span className="info-value">{match.room_id || 'Not set'}</span>
                    </div>
                  </div>
                  
                  <div className="info-row">
                    <FaLock className="info-icon" />
                    <div className="info-text">
                      <span className="info-label">Password:</span>
                      <span className="info-value">
                        {match.room_password || 'No password'}
                      </span>
                    </div>
                  </div>
                  
                  <div className="info-row">
                    <FaUsers className="info-icon" />
                    <div className="info-text">
                      <span className="info-label">Players:</span>
                      <span className="info-value">
                        {match.current_players || '?'}/{match.max_players || 'N/A'}
                      </span>
                    </div>
                  </div>

                      <div className="info-row">
                    <FaCalendarAlt className="info-icon" />
                    <div className="info-text">
                      <span className="info-label">Started At:</span>
                      <span className="info-value">
                        {match.text_time}
                      </span>
                    </div>
                  </div>
            

                </div>

               
                
               
              </div>
            ))}
          </div>
        )}
      </div>

      <BottomBar />
    </div>
  );
};

export default OngoingMatches;